export default __webpack_public_path__ + "static/media/MarsCentra-Book.179848f3.svg";